import sidePanel from 'side-panel-menu-thing'
import BigPicture from 'bigpicture'
import Navbar from '../components/navbar.svelte'
import Popup from '../components/popup.svelte'
import teamPopup from '../components/team-popup.svelte'
import sal from 'sal.js'
import { tns } from '../../node_modules/tiny-slider/src/tiny-slider'
import tippy from 'tippy.js'
import Accordion from '../components/accordion-block.svelte'
import customSearch from '../lib/search'

const { $, boostPopupOptions } = window

const $body = $(document.body)

export default {
	init() {
		// JavaScript to be fired on all pages
		let navbarContainer = document.getElementById('navbar_container')
		navbarContainer &&
			new Navbar({
				target: navbarContainer,
			})

		const mobileMenu = new sidePanel({
			target: $body[0],
			props: {
				target: $body[0],
				content: document.getElementById('menu'),
				fixed: true,
				width: 320,
			},
		})
		$('#toggle_nav').on('click', mobileMenu.show)

		$(document).on(
			'click',
			'.menu-section .menu-item-has-children > a',
			function (e) {
				e.preventDefault()
				let $el = $(this)
				$el.parent().toggleClass('show-subnav')
			}
		)

		sal({
			threshold: 0.01,
			rootMargin: '-25px 9px',
		})

		// Back to Top code
		document.addEventListener('DOMContentLoaded', function () {
			const returnToTopButton = document.getElementById('return-to-top')

			// Show/hide button based on scroll position
			window.addEventListener('scroll', function () {
				if (window.scrollY > 300) {
					returnToTopButton.classList.add('show')
				} else {
					returnToTopButton.classList.remove('show')
				}
			})

			// Scroll to top when button is clicked
			returnToTopButton.addEventListener('click', function () {
				window.scrollTo({
					top: 0,
					behavior: 'smooth',
				})
			})
		})

		new teamPopup({
			target: document.body,
		})

		customSearch()
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		// class to hide outlines if not using keyboard
		$body.on('mousedown', function () {
			$body.addClass('using-mouse')
		})
		$body.on('keydown', function () {
			$body.removeClass('using-mouse')
		})

		let $blocksGallery = $('.wp-block-gallery .wp-block-image:not(.no-bp)  > a')
		if ($blocksGallery.length) {
			let $caption = $('.blocks-gallery-item__caption')
			if ($caption) {
				$caption.each(function () {
					$(this).siblings('a')[0].setAttribute('data-caption', $(this).text())
				})
			}

			$blocksGallery.each(function (index, el) {
				el.setAttribute('data-bp', el.href)
			})

			$blocksGallery.on('click', function (e) {
				e.preventDefault()
				BigPicture({
					el: this,
					gallery: '.wp-block-gallery',
					loop: true,
					noLoader: true,
				})
			})
		}

		let $wpBlockImg = $('.wp-block-image:not(.no-bp) > img')
		if ($wpBlockImg.length) {
			$wpBlockImg.on('click', function (e) {
				const $this = $(this)
				const $imgEls = $this.find('img')
				e.preventDefault()
				BigPicture({
					el: $imgEls.length ? $imgEls[0] : this,
					imgSrc: this.href,
				})
			})
		}

		let $wpMediaTxtBlockImg = $(
			'.wp-block-media-text:not(.no-bp) .wp-block-media-text__media'
		)
		if ($wpMediaTxtBlockImg.length) {
			$wpMediaTxtBlockImg.on('click', function (e) {
				const $this = $(this)
				const $imgEls = $this.find('img')
				e.preventDefault()
				BigPicture({
					el: $imgEls.length ? $imgEls[0] : this,
					imgSrc: this.href,
				})
			})
		}

		if (boostPopupOptions) {
			new Popup({
				target: document.body,
				props: {
					options: boostPopupOptions,
				},
			})
		}

		let $homeSliderWrap = document.querySelectorAll('.home-slider-wrap')
		if ($homeSliderWrap.length) {
			$homeSliderWrap.forEach((item) => {
				tns({
					container: item,
					items: 1,
					slideBy: 1,
					autoplay: true,
					nav: true, //dots
					controls: false, //arrows
					touch: true,
					autoplayButtonOutput: false,
					autoplayHoverPause: true,
					speed: 450,
					loop: false,
					rewind: true,
					controlsText: [
						'<span class="sr-only">Previous</span><svg xmlns="http://www.w3.org/2000/svg" width="109" height="83"><defs><filter filterUnits="userSpaceOnUse" id="a" x="0" y="0" width="109" height="83"><feOffset in="SourceAlpha" dy="4"/><feGaussianBlur result="blurOut" stdDeviation="3.162"/><feFlood flood-color="#1F1C1D" result="floodOut"/><feComposite operator="atop" in="floodOut" in2="blurOut"/><feComponentTransfer><feFuncA type="linear" slope=".41"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs><g filter="url(#a)"><path fill-rule="evenodd" fill="#FFF" d="M43.646 67.612c1.655-1.693 1.655-4.427 0-6.119L24.005 41.571h70.426c2.358 0 4.27-1.942 4.27-4.339 0-2.398-1.912-4.341-4.27-4.341H24.133l19.513-19.832c1.686-1.703 1.696-4.471.021-6.186-1.674-1.714-4.398-1.722-6.084-.02L10.428 34.497c-1.493 1.525-1.493 3.988 0 5.513l27.155 27.602c1.661 1.701 4.364 1.712 6.038.025.008-.009.017-.017.025-.025Z"/></g></svg>',
						'<span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" width="109" height="83"><defs><filter filterUnits="userSpaceOnUse" id="a" x="0" y="0" width="109" height="83"><feOffset in="SourceAlpha" dy="4"/><feGaussianBlur result="blurOut" stdDeviation="3.162"/><feFlood flood-color="#1F1C1D" result="floodOut"/><feComposite operator="atop" in="floodOut" in2="blurOut"/><feComponentTransfer><feFuncA type="linear" slope=".41"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs><g filter="url(#a)"><path fill-rule="evenodd" fill="#FFF" d="M64.354 67.612c-1.655-1.693-1.655-4.427 0-6.119l19.641-19.922H13.569c-2.358 0-4.27-1.942-4.27-4.339 0-2.398 1.912-4.341 4.27-4.341h70.298L64.354 13.059c-1.686-1.703-1.696-4.471-.021-6.186 1.674-1.714 4.398-1.722 6.084-.02l27.155 27.644c1.493 1.525 1.493 3.988 0 5.513L70.417 67.612c-1.661 1.701-4.364 1.712-6.038.025-.008-.009-.017-.017-.025-.025Z"/></g></svg>',
					],
					responsive: {
						767: {
							nav: false, //dots
							controls: true, //arrows
						},
					},
				})
			})
		}

		let $reviewCarouselBlockInner = document.querySelectorAll(
			'.review-carousel-block-inner'
		)
		if ($reviewCarouselBlockInner.length) {
			$reviewCarouselBlockInner.forEach((item) => {
				tns({
					container: item,
					items: 1,
					slideBy: 1,
					autoplay: true,
					nav: true, //dots
					controls: false, //arrows
					touch: true,
					autoplayButtonOutput: false,
					autoplayHoverPause: true,
					speed: 450,
					loop: false,
					rewind: true,
					controlsText: [
						'<span class="sr-only">Previous</span><svg xmlns="http://www.w3.org/2000/svg" width="109" height="83"><defs><filter filterUnits="userSpaceOnUse" id="a" x="0" y="0" width="109" height="83"><feOffset in="SourceAlpha" dy="4"/><feGaussianBlur result="blurOut" stdDeviation="3.162"/><feFlood flood-color="#1F1C1D" result="floodOut"/><feComposite operator="atop" in="floodOut" in2="blurOut"/><feComponentTransfer><feFuncA type="linear" slope=".41"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs><g filter="url(#a)"><path fill-rule="evenodd" fill="#FFF" d="M43.646 67.612c1.655-1.693 1.655-4.427 0-6.119L24.005 41.571h70.426c2.358 0 4.27-1.942 4.27-4.339 0-2.398-1.912-4.341-4.27-4.341H24.133l19.513-19.832c1.686-1.703 1.696-4.471.021-6.186-1.674-1.714-4.398-1.722-6.084-.02L10.428 34.497c-1.493 1.525-1.493 3.988 0 5.513l27.155 27.602c1.661 1.701 4.364 1.712 6.038.025.008-.009.017-.017.025-.025Z"/></g></svg>',
						'<span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" width="109" height="83"><defs><filter filterUnits="userSpaceOnUse" id="a" x="0" y="0" width="109" height="83"><feOffset in="SourceAlpha" dy="4"/><feGaussianBlur result="blurOut" stdDeviation="3.162"/><feFlood flood-color="#1F1C1D" result="floodOut"/><feComposite operator="atop" in="floodOut" in2="blurOut"/><feComponentTransfer><feFuncA type="linear" slope=".41"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs><g filter="url(#a)"><path fill-rule="evenodd" fill="#FFF" d="M64.354 67.612c-1.655-1.693-1.655-4.427 0-6.119l19.641-19.922H13.569c-2.358 0-4.27-1.942-4.27-4.339 0-2.398 1.912-4.341 4.27-4.341h70.298L64.354 13.059c-1.686-1.703-1.696-4.471-.021-6.186 1.674-1.714 4.398-1.722 6.084-.02l27.155 27.644c1.493 1.525 1.493 3.988 0 5.513L70.417 67.612c-1.661 1.701-4.364 1.712-6.038.025-.008-.009-.017-.017-.025-.025Z"/></g></svg>',
					],
					responsive: {
						767: {
							nav: false, //dots
							controls: true, //arrows
						},
					},
				})
			})
		}

		let $logoCarouselBlock = document.querySelectorAll(
			'.logo-carousel-block-wrap'
		)
		if ($logoCarouselBlock.length) {
			$logoCarouselBlock.forEach((item) => {
				tns({
					container: item,
					slideBy: 1,
					autoplay: true,
					autoplayTimeout: 1500,
					nav: false, //dots
					controls: false, //arrows
					touch: true,
					autoplayButtonOutput: false,
					autoplayHoverPause: true,
					speed: 1000,
					loop: false,
					rewind: true,
					gutter: 20,
					edgePadding: 40,
					animateIn: 'tns-fadeIn',
					animateOut: 'tns-fadeOut',
					lazyload: true,
					controlsText: [
						'<svg xmlns="http://www.w3.org/2000/svg" width="109" height="83"><defs><filter filterUnits="userSpaceOnUse" id="a" x="0" y="0" width="109" height="83"><feOffset in="SourceAlpha" dy="4"/><feGaussianBlur result="blurOut" stdDeviation="3.162"/><feFlood flood-color="#1F1C1D" result="floodOut"/><feComposite operator="atop" in="floodOut" in2="blurOut"/><feComponentTransfer><feFuncA type="linear" slope=".41"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs><g filter="url(#a)"><path fill-rule="evenodd" fill="#FFF" d="M43.646 67.612c1.655-1.693 1.655-4.427 0-6.119L24.005 41.571h70.426c2.358 0 4.27-1.942 4.27-4.339 0-2.398-1.912-4.341-4.27-4.341H24.133l19.513-19.832c1.686-1.703 1.696-4.471.021-6.186-1.674-1.714-4.398-1.722-6.084-.02L10.428 34.497c-1.493 1.525-1.493 3.988 0 5.513l27.155 27.602c1.661 1.701 4.364 1.712 6.038.025.008-.009.017-.017.025-.025Z"/></g></svg>',
						'<svg xmlns="http://www.w3.org/2000/svg" width="109" height="83"><defs><filter filterUnits="userSpaceOnUse" id="a" x="0" y="0" width="109" height="83"><feOffset in="SourceAlpha" dy="4"/><feGaussianBlur result="blurOut" stdDeviation="3.162"/><feFlood flood-color="#1F1C1D" result="floodOut"/><feComposite operator="atop" in="floodOut" in2="blurOut"/><feComponentTransfer><feFuncA type="linear" slope=".41"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs><g filter="url(#a)"><path fill-rule="evenodd" fill="#FFF" d="M64.354 67.612c-1.655-1.693-1.655-4.427 0-6.119l19.641-19.922H13.569c-2.358 0-4.27-1.942-4.27-4.339 0-2.398 1.912-4.341 4.27-4.341h70.298L64.354 13.059c-1.686-1.703-1.696-4.471-.021-6.186 1.674-1.714 4.398-1.722 6.084-.02l27.155 27.644c1.493 1.525 1.493 3.988 0 5.513L70.417 67.612c-1.661 1.701-4.364 1.712-6.038.025-.008-.009-.017-.017-.025-.025Z"/></g></svg>',
					],
					responsive: {
						1200: {
							items: 7,
						},
						800: {
							items: 5,
						},
						400: {
							items: 3,
						},
						0: {
							items: 2,
						},
					},
				})
			})
		}

		let $videoContentBlockLink = $('#video_link')
		if ($videoContentBlockLink.length) {
			$videoContentBlockLink.on('click', function (e) {
				e.preventDefault()
				// let $thisParent = $(this).parent()
				// $thisParent.addClass('vr-fade')
				let $this = $(this)
				let ytSrc = $this.data('yt')
				let vidSrc = $this.data('video')

				if (vidSrc) {
					BigPicture({
						el: this,
						vidSrc,
						noLoader: true,
						// animationEnd: () => $thisParent.removeClass('vr-fade'),
					})
				} else if (ytSrc == undefined) {
					let vimeoSrc = $this.data('vimeo')
					BigPicture({
						el: this,
						vimeoSrc,
						noLoader: true,
						// animationEnd: () => $thisParent.removeClass('vr-fade'),
					})
				} else {
					BigPicture({
						el: this,
						ytSrc,
						noLoader: true,
						// animationEnd: () => $thisParent.removeClass('vr-fade'),
					})
				}
			})
		}

		let $accordionBlock = $('.accordion-block-inner')
		if ($accordionBlock.length) {
			$accordionBlock.each(function () {
				new Accordion({
					target: $(this)[0],
					props: $(this).data(),
				})
			})
		}

		if ($('.layered-content-block').length) {
			scrollToNumberAnimation()
		}
		if ($('.values-block').length) {
			valuesBlockPopups()
		}
	},
}
function scrollToNumberAnimation() {
	$(window).scroll(function () {
		// This is then function used to detect if the element is scrolled into view
		function elementScrolled(elem) {
			var docViewTop = $(window).scrollTop()
			var docViewBottom = docViewTop + $(window).height()
			var elemTop = $(elem).offset().top
			return elemTop <= docViewBottom && elemTop >= docViewTop
		}

		if (elementScrolled($('.layered-content-block')[0])) {
			setTimeout(() => {
				numberAnimation()
			}, 500)
			$(window).unbind('scroll')
		}
	})
}

function numberAnimation() {
	$('.count').each(function () {
		$(this)
			.prop('Counter', 0)
			.animate(
				{
					Counter: $(this).text(),
				},
				{
					duration: 2500,
					easing: 'swing',
					step: function (now) {
						$(this).text(Math.ceil(now))
					},
				}
			)
	})
}

function valuesBlockPopups() {
	const items = document.querySelectorAll('.values-block .values-item')
	if (!items.length) {
		return
	}

	const isMobile = window.matchMedia('(max-width: 900px)').matches

	items.forEach((item) => {
		const popupEl = item.querySelector('.values-item-popup')
		if (!popupEl) {
			return
		}

		tippy(item, {
			content: popupEl.innerHTML, // preserve formatting
			allowHTML: true,
			arrow: true,
			theme: 'light',
			animation: 'scale-subtle',
			appendTo: () => document.body, // escape overflow/clipping
			placement: isMobile ? 'bottom-start' : 'right',
			offset: [0, 8],
			maxWidth: isMobile ? 260 : 320,
			popperOptions: {
				modifiers: [
					{
						name: 'preventOverflow',
						options: {
							boundary: 'viewport',
							padding: 8,
						},
					},
					{
						name: 'flip',
						options: {
							fallbackPlacements: ['bottom', 'top', 'right', 'left'],
						},
					},
				],
			},
		})
	})
}
